export default __webpack_public_path__ + "static/media/warningIcon.3ab8fc7e.svg";